if (!customElements.get("summary-text")) {
  class SummaryText extends HTMLElement {
    constructor() {
      super();

      this.handleUpdateRef = this.handleUpdate.bind(this);
      this.handleRemoveRef = this.handleRemove.bind(this);
      this.isEmpty = true;
    }

    /**
     * @param {SummaryEvent} event
     */
    handleRemove(event) {
      const element = this.querySelector(`[data-product-id="${event.detail.productId + event.detail.position}"]`);
      if(!element) return;

      element.remove();
    }

    /**
     * @param {SummaryEvent} event
     */
    handleUpdate(event) {
      const p = document.createElement("p");
      p.innerHTML = event.detail.text;
      p.setAttribute(
        "data-product-id",
        event.detail.productId + event.detail.position
      );

      if (this.isEmpty) {
        this.innerHTML = "";
      }

      const current = this.querySelector(
        `[data-product-id="${event.detail.productId + event.detail.position}"]`
      );
      if (!current) {
        this.appendChild(p);
      } else {
        current.innerHTML = p.innerHTML;
      }

      this.isEmpty = false;
    }

    disconnectedCallback() {
      document.removeEventListener("summary:update", this.handleUpdateRef);
      document.removeEventListener("summary:remove", this.handleRemoveRef);
    }

    connectedCallback() {
      document.addEventListener("summary:update", this.handleUpdateRef);
      document.addEventListener("summary:remove", this.handleRemoveRef);
    }
  }

  customElements.define("summary-text", SummaryText);
}
